<template>

    <div class="vx-row">
        <div class="vx-col w-full mb-3">
            <vx-card title="CPU Usage" id="cpuCard" class="vs-con-loading__container">

                <template slot="actions">
                    <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                        <small class="flex cursor-pointer">
                            <span>{{metricTimes[cpuRange]}}</span>
                            <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                        </small>
                        <vs-dropdown-menu class="w-48">
                            <vs-dropdown-item @click="cpuRange = 1">Last hour</vs-dropdown-item>
                            <vs-dropdown-item @click="cpuRange = 6">Last 6 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="cpuRange = 12">Last 12 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="cpuRange = 24">Last 24 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="cpuRange = 167">Last 7 days</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <feather-icon icon="RefreshCwIcon" @click="loadCPUData()"></feather-icon>
                </template>

                <vue-apex-charts v-if="cpuChartOptions" type="line" height="500" :options="cpuChartOptions" :series="cpuData"/>

            </vx-card>
        </div>

        <div class="vx-col w-full mb-3">
            <vx-card title="Worker Load" id="loadCard" class="vs-con-loading__container">

                <template slot="actions">
                    <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                        <small class="flex cursor-pointer">
                            <span>{{metricTimes[loadRange]}}</span>
                            <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                        </small>
                        <vs-dropdown-menu class="w-48">
                            <vs-dropdown-item @click="loadRange = 1">Last hour</vs-dropdown-item>
                            <vs-dropdown-item @click="loadRange = 6">Last 6 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="loadRange = 12">Last 12 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="loadRange = 24">Last 24 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="loadRange = 167">Last 7 days</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <feather-icon icon="RefreshCwIcon" @click="loadLoadData()"></feather-icon>
                </template>

                <vue-apex-charts v-if="loadChartOptions" type="line" height="350" :options="loadChartOptions" :series="cpuLoadData"/>

            </vx-card>
        </div>

        <div class="vx-col w-full xl:w-1/2 w-full mb-3">
            <vx-card title="Memory" id="memoryCard" class="vs-con-loading__container">

                <template slot="actions">
                    <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                        <small class="flex cursor-pointer">
                            <span>{{metricTimes[memoryRange]}}</span>
                            <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                        </small>
                        <vs-dropdown-menu class="w-48">
                            <vs-dropdown-item @click="memoryRange = 1">Last hour</vs-dropdown-item>
                            <vs-dropdown-item @click="memoryRange = 6">Last 6 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="memoryRange = 12">Last 12 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="memoryRange = 24">Last 24 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="memoryRange = 167">Last 7 days</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <feather-icon icon="RefreshCwIcon" @click="loadMemoryData()"></feather-icon>
                </template>

                <vue-apex-charts v-if="memoryChartOptions" type="line" height="350" :options="memoryChartOptions" :series="memoryData"/>

            </vx-card>
        </div>

        <div class="vx-col w-full xl:w-1/2 w-full mb-3">
            <vx-card title="Memory Utilization" id="memoryPercentageCard" class="vs-con-loading__container">

                <template slot="actions">
                    <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                        <small class="flex cursor-pointer">
                            <span>{{metricTimes[memoryPercentageRange]}}</span>
                            <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                        </small>
                        <vs-dropdown-menu class="w-48">
                            <vs-dropdown-item @click="memoryPercentageRange = 1">Last hour</vs-dropdown-item>
                            <vs-dropdown-item @click="memoryPercentageRange = 6">Last 6 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="memoryPercentageRange = 12">Last 12 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="memoryPercentageRange = 24">Last 24 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="memoryPercentageRange = 167">Last 7 days</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <feather-icon icon="RefreshCwIcon" @click="loadMemoryPercentageData()"></feather-icon>
                </template>

                <vue-apex-charts v-if="memoryPercentageChartOptions" type="line" height="350" :options="memoryPercentageChartOptions" :series="memoryPercentageData"/>

            </vx-card>
        </div>

        <div class="vx-col w-full xl:w-1/2 w-full mb-3">
            <vx-card title="Swap" id="swapCard" class="vs-con-loading__container">

                <template slot="actions">
                    <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                        <small class="flex cursor-pointer">
                            <span>{{metricTimes[swapRange]}}</span>
                            <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                        </small>
                        <vs-dropdown-menu class="w-48">
                            <vs-dropdown-item @click="swapRange = 1">Last hour</vs-dropdown-item>
                            <vs-dropdown-item @click="swapRange = 6">Last 6 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="swapRange = 12">Last 12 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="swapRange = 24">Last 24 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="swapRange = 167">Last 7 days</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <feather-icon icon="RefreshCwIcon" @click="loadSwapData()"></feather-icon>
                </template>

                <vue-apex-charts v-if="swapChartOptions" type="line" height="350" :options="swapChartOptions" :series="swapData"/>

            </vx-card>
        </div>

        <div class="vx-col w-full xl:w-1/2 w-full mb-3">
            <vx-card title="Swap Utilization" id="swapPercentageCard" class="vs-con-loading__container">

                <template slot="actions">
                    <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                        <small class="flex cursor-pointer">
                            <span>{{metricTimes[swapPercentageRange]}}</span>
                            <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                        </small>
                        <vs-dropdown-menu class="w-48">
                            <vs-dropdown-item @click="swapPercentageRange = 1">Last hour</vs-dropdown-item>
                            <vs-dropdown-item @click="swapPercentageRange = 6">Last 6 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="swapPercentageRange = 12">Last 12 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="swapPercentageRange = 24">Last 24 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="swapPercentageRange = 167">Last 7 days</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <feather-icon icon="RefreshCwIcon" @click="loadSwapPercentageData()"></feather-icon>
                </template>

                <vue-apex-charts v-if="swapPercentageChartOptions" type="line" height="350" :options="swapPercentageChartOptions" :series="swapPercentageData"/>

            </vx-card>
        </div>

    </div>

</template>
<script>
    import VueApexCharts from 'vue-apexcharts'

    export default {
        components: {
            VueApexCharts
        },
        data() {
            return {
                cpuData: [],
                cpuLoadData: [],
                memoryData: [],
                memoryPercentageData: [],
                swapData: [],
                swapPercentageData: [],

                cpuRange: 1,
                loadRange: 1,
                memoryRange: 1,
                memoryPercentageRange: 1,
                swapRange: 1,
                swapPercentageRange: 1,

                metricTimes: {
                    1: 'Last hour',
                    6: 'Last 6 hours',
                    12: 'Last 12 hours',
                    24: 'Last 24 hours',
                    167: 'Last 7 days'

                },

                cpuChartOptions: null,
                loadChartOptions: null,
                memoryChartOptions: null,
                memoryPercentageChartOptions: null,
                swapChartOptions: null,
                swapPercentageChartOptions: null
            }
        },
        methods: {
            loadData() {
                this.cpuChartOptions = this.getCPUPercentageChartOptions('CPU Utilization', ['#2ecc71', '#3498db', '#f1c40f', '#e74c3c', '#e67e22', '#9b59b6', '#34495e', '#1abc9c', '#95a5a6', '#c0392b', '#7f8c8d', '#27ae60', '#2980b9', '#16a085', '#f39c12', '#d35400', '#8e44ad', '#2c3e50'], '%')
                this.loadChartOptions = this.getMetricsChartOptions('Worker Load', ['#7367F0', '#28C76F', '#EA5455'], '')
                this.memoryChartOptions = this.getMetricsChartOptions('Memory', ['#7367F0', '#28C76F'], 'GB')
                this.memoryPercentageChartOptions = this.getPercentageChartOptions('Memory Utilization', ['#7367F0'], '%')
                this.swapChartOptions = this.getMetricsChartOptions('Swap', ['#7367F0', '#28C76F'], 'GB')
                this.swapPercentageChartOptions = this.getPercentageChartOptions('Swap Utilization', ['#7367F0'], '%')

                this.loadCPUData()
                this.loadLoadData()
                this.loadMemoryData()
                this.loadMemoryPercentageData()
                this.loadSwapData()
                this.loadSwapPercentageData()
            },
            loadCPUData() {
                this.loadDataToObject('cpu', this.cpuRange, 'cpuData', '#cpuCard')
            },
            loadLoadData() {
                this.loadDataToObject('load', this.loadRange, 'cpuLoadData', '#loadCard')
            },
            loadMemoryData() {
                this.loadDataToObject('memory', this.memoryRange, 'memoryData', '#memoryCard')
            },
            loadMemoryPercentageData() {
                this.loadDataToObject('memory_percent', this.memoryPercentageRange, 'memoryPercentageData', '#memoryPercentageCard')
            },
            loadSwapData() {
                this.loadDataToObject('swap', this.swapRange, 'swapData', '#swapCard')
            },
            loadSwapPercentageData() {
                this.loadDataToObject('swap_percent', this.swapPercentageRange, 'swapPercentageData', '#swapPercentageCard')
            },
            loadDataToObject(metric, time, objectName, loaderElement) {
                this.$vs.loading({
                    container: loaderElement,
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker/' + this.$route.params.id + '/metrics/' + metric + '/' + time)
                loadPromise.then(function(response) {
                    thisIns[objectName] = JSON.parse(JSON.stringify(response.data))
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                loadPromise.finally(function() {
                    thisIns.$vs.loading.close(loaderElement + ' > .con-vs-loading')
                })
            },
            getMetricsChartOptions(title, colors, unit) {
                return {
                    colors: colors,
                    xaxis: {
                        type: 'datetime',
                        tickAmount: 6,
                        labels: {
                            datetimeUTC: false
                        }
                    },
                    yaxis: {
                        decimalsInFloat: 2,
                        labels: {
                            formatter: function(value) {
                                return value.toFixed(2) + unit
                            }
                        }
                    },
                    tooltip: {
                        x: {
                            format: 'dd/MM/yyyy HH:mm:ss'
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'straight'
                    },
                    title: {
                        text: title,
                        align: 'left'
                    }
                }
            },
            getPercentageChartOptions(title, colors, unit) {
                return {
                    colors: colors,
                    xaxis: {
                        type: 'datetime',
                        tickAmount: 6,
                        labels: {
                            datetimeUTC: false
                        }
                    },
                    yaxis: {
                        min: 0,
                        max: 100,
                        tickAmount: 5,
                        decimalsInFloat: 2,
                        labels: {
                            formatter: function(value) {
                                return value.toFixed(2) + unit
                            }
                        }
                    },
                    tooltip: {
                        x: {
                            format: 'dd/MM/yyyy HH:mm:ss'
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'straight'
                    },
                    title: {
                        text: title,
                        align: 'left'
                    }
                }
            },
            getCPUPercentageChartOptions(title, colors, unit) {
                return {
                    colors: colors,
                    xaxis: {
                        type: 'datetime',
                        tickAmount: 6,
                        labels: {
                            datetimeUTC: false
                        }
                    },
                    yaxis: {
                        min: 0,
                        max: 100,
                        tickAmount: 5,
                        decimalsInFloat: 2,
                        labels: {
                            formatter: function(value) {
                                return value.toFixed(2) + unit
                            }
                        }
                    },
                    tooltip: {
                        x: {
                            format: 'dd/MM/yyyy HH:mm:ss'
                        },
                        style: {
                            fontSize: '11px'
                        },
                        fixed: {
                            enabled: true,
                            position: 'topLeft',
                            offsetX: 0,
                            offsetY: 20
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'straight'
                    },
                    title: {
                        text: title,
                        align: 'left'
                    }
                }
            }
        },
        watch: {
            cpuRange() {
                this.loadCPUData()
            },
            loadRange() {
                this.loadLoadData()
            },
            memoryRange() {
                this.loadMemoryData()
            },
            memoryPercentageRange() {
                this.loadMemoryPercentageData()
            },
            swapRange() {
                this.loadSwapData()
            },
            swapPercentageRange() {
                this.loadSwapPercentageData()
            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>
